export const ProductName = "Green Crypto";
